import { Descriptions, Form, Button, Col, Input, Row, Select, FormInstance, Switch, message, Divider, Spin, Skeleton, Collapse, Tooltip } from 'antd'
import Helper from '../utils/helper';
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { CommonDrawer, OutPutResult, Spinner, FewRequests, CreateRequestAction, CancelRequest, TruckingModal, SendUserOtp } from '@operations/shared';
import { getApi, patchApi, postApi } from '../apis';
import { stepperMoving } from '../stores/actions';
import { getUserFreePeriodsApis, getUserTagsApi, unblockUserLoginApi } from '../utils/apisConsts';
import { InfoCircleOutlined } from '@ant-design/icons';
import { FalseIcon, TrueIcon } from '../utils/commonIcons';
import CollectionPlans from './collectionPlans';
// import { CallCenterModules } from '../utils/commonInterfaces';
import { errorMessage } from '../utils/commonStringsConsts';
import helper from '../utils/helper';
import { Link } from 'react-router-dom';
import ViewEarlySettlement from '../unSharedComponents/eg/viewEarlySettlement';
import { Region, UsageLevelTags, UserTag, UserTagCategories } from '../utils/commonInterfaces';
import { renderUsageLevelFlag } from '../unSharedComponents/eg/UserTagsLevel';
import { getRegion } from '../components/regionWrapper';

const { Option } = Select;
const { Panel } = Collapse;


interface Props {
    info?: { name: string, staff_id: number, companyName: string, userID: number, phone: string, companyID: any, actualCutOffDate: string, userTags: UserTag[], isLoginBlocked?: boolean },
    getApi: any,
    postApi: any,
    patchApi: any,
    stepperMoving: any,
}
class CallInfo extends Component<Props> {
    formRef = React.createRef<FormInstance>();
    region = getRegion()
    commonCallTypes = [{ id: 1, name: 'Call' }, { id: 2, name: 'Whats App' }]

    state = {
        subDrawer: false,
        drawerLayout: null,
        drawerChildLayout: null,
        subChildDrawer: false,
        visibleModal: false,

        status: [],
        reasons: [],
        modules: [],
        details: [],
        teamName: '',
        errorMode: false,
        loadData: false,
        errorMessage: '',
        title: '',
        sendCallDataSpin: false,
        titleChild: '',
        otherComment: false,
        drawerWidth: '',
        teamID: 0,
        seconds: 0,
        callTypes: this.region === Region.SE ? this.commonCallTypes : [...this.commonCallTypes, { id: 3, name: 'Ticket' }],
        outboundCall: false,
        outboundData: false,
        freePeriodsData: {
            freePeriodsEndDate: '',
            companyDeploymentDate: '',
            companyFreePeriod: '',
            userFirstRequestDate: '',
            userVIPStartDate: '',
            userVIPFreePeriod: '',
            companyUsersFreePeriod: '',
            companyUsersFreePeriodStarted: null,
            cutOffDay: '',
            freePeriodOnDeductions: ""
        },
        paymentCycles: [],
        loadingPaymentCycles: false,
        mainTagItems: [],
        behavioralTagItems: [],
        usageLevelItems: [],
        selectedMainTag: null,
        selectedBehavioralTag: null,
        selectedUsageLevel: null,
        selectedSubTag: null,
        subTagItems: [],
        usageLevelTag: null,
        hasUserChangedMainTag: false,
        loadingTags: true,
        isVerified: false,
        isLoginBlocked: false,
        updatingLoginStatus: false,
    }
    private time: any;


    async componentDidMount() {
        this.timer();
        this.setState({ isLoginBlocked: this.props.info?.isLoginBlocked });
        await this.getDropDawns(`/callCenter/getCallCenterReasons?outboundCall=${this.state.outboundCall}`, 'reasons');
        await this.getDropDawns(`/callCenter/getCallCenterModules?outboundCall=${this.state.outboundCall}`, 'modules');
        await this.getUserFreePeriods();
        if (this.region === Region.EG) {
            await this.getDropDawns('/callCenter/getCallCenterStatuses', 'status');
            await this.getMainDropdowns();
            // await this.getPaymentCycles();
        }
    }

    handleLoginBlockedChange = async (checked: boolean) => {
        if (checked || this.state.updatingLoginStatus) {
            return;
        }

        this.setState({ updatingLoginStatus: true });
        try {
            const response = await this.props.patchApi(unblockUserLoginApi + `?userID=${this.props.info?.userID}`);
            const res = response?.payload;
            if (res?.status === 200) {
                this.setState({ isLoginBlocked: false, updatingLoginStatus: false });
                message.success(res?.message || 'User login has been unblocked');
            } else {
                this.setState({ updatingLoginStatus: false });
                message.error(errorMessage);
            }
        } catch (error) {
            this.setState({ updatingLoginStatus: false });
            message.error(errorMessage);
        }
    }

    getDropDawns = async (apiLink: string, dynamicState: string, shouldLoad?: boolean) => {
        this.setState({ loadData: !shouldLoad ? false : true })
        const drops = await this.props.getApi(apiLink);
        const res = await drops.payload;
        try {
            if (res.status === 200) {
                this.setState({ [dynamicState]: res.data, loadData: false, outboundData: false })
                this.formRef.current!.setFieldsValue({ details: null, reason: null, module: null });

            } else {
                this.setState({ loadData: false, outboundData: false, errorMode: true })
            }
        } catch (error) {
            this.setState({ loadData: false, outboundData: false, errorMode: true })
        }
    }
    openDrawer = (layout: any, title: string) => {
        this.setState({ subDrawer: true, drawerLayout: layout, title: title, drawerWidth: 1000 })
    }
    closeDrawer = () => {
        this.setState({ subDrawer: false })
    }
    openChildDrawer = (layout: any, title: string) => {
        this.setState({ subChildDrawer: true, drawerChildLayout: layout, titleChild: title, drawerWidth: 1000 })
    }
    closeChildDrawer = () => {
        this.setState({ subChildDrawer: false, drawerWidth: 985 })
    }
    endCall = async (value: any) => {
        console.log(value);
        const userTags = [value?.mainSubTag ? value?.mainSubTag : value?.mainTag, value?.behavioralTag, value?.usageLevel]?.filter(Boolean);

        let userId = this.props.info;
        const data = {
            userID: userId && userId.userID,
            statusID: this.region === Region.SE ? 2 : value.status,
            callComment: value.comment,
            reasons: [value.reason],
            details: [value.details],
            detailComment: value.otherComment,
            openZoho: value.openZohoTicket,
            callInterrupted: value.callInteracted,
            teamID: this.state.teamID,
            duration: this.state.seconds,
            callType: value.callType,
            outboundCall: value.outboundCall,
            ...(this.region === Region.EG && { userTags: userTags?.length ? userTags : undefined }),
            ...(this.region === Region.EG && { isVerified: value.isVerified }),
        }
        this.setState({ sendCallDataSpin: true })
        const endingCall = await this.props.postApi('/callCenter/addCallInfo', data);

        try {
            const res = endingCall.payload;
            if (res?.status === 200) {
                console.log(res);
                this.setState({ sendCallDataSpin: false });
                message.success(res.message)
                this.props.stepperMoving(0)
                this.onReset();
            }
            else {
                this.setState({ sendCallDataSpin: false })
                if (res?.message) message.error(res?.message, 5)
                else message.error(errorMessage, 5)
            }
        } catch (error) {
            this.setState({ sendCallDataSpin: false })
            console.log(error);
            message.error('Something went wrong, please try again');

        }

    }
    refreshPage = () => {
        window.location.reload();
    }
    onOtherSelected = (value: any, detail: any) => {
        console.log(detail.name.name);

        if (detail.name.name.includes('Other')) {
            this.setState({ otherComment: true })
            return
        }
        this.setState({ otherComment: false })

    }
    gettingDetails = (selectId: number, module: any) => {
        // if (this.state.outboundCall && selectId === CallCenterModules.willPay) this.setState({ visibleModal: true });
        this.setState({ details: module?.module?.CallCenterDetails, teamName: module?.module?.team, teamID: module?.module?.teamID });
        this.formRef.current!.setFieldsValue({ details: null });
    }
    onStart = () => {
        this.setState({ seconds: this.state.seconds + 1 });
    }
    timer = () => {
        this.time = setInterval(this.onStart, 1000);
    }
    onReset = () => {
        clearInterval(this.time);
        this.setState({ seconds: 0 })
    }

    outBoundChange = (e: boolean) => {
        this.setState({ outboundCall: e, outboundData: true }, async () => {
            await this.getDropDawns(`/callCenter/getCallCenterReasons?outboundCall=${this.state.outboundCall}`, 'reasons', false);
            await this.getDropDawns(`/callCenter/getCallCenterModules?outboundCall=${this.state.outboundCall}`, 'modules', false);
        });

    }
    getUserFreePeriods = async () => {
        const freePeriods = await this.props.getApi(`${getUserFreePeriodsApis}?userID=${this.props.info?.userID}`);
        const res = await freePeriods.payload;
        try {
            if (res.status === 200) {
                console.log(res.data);
                this.setState({ freePeriodsData: res.data })
            } else {
                console.log('error');

            }
        } catch (error) {
            console.log(error);

        }

    }
    handleToggleTheModal = () => {
        this.setState({ visibleModal: !this.state.visibleModal });
    }

    getPaymentCycles = async () => {
        this.setState({ loadingPaymentCycles: true })

        try {
            const paymentCyclesRes: any = await helper.getPaymentCycles(this.props?.info?.companyID, false, this.props?.info?.actualCutOffDate, true, true)
            console.log(paymentCyclesRes)
            if (!paymentCyclesRes?.errorMessage) {
                this.setState({ loadingPaymentCycles: true, paymentCycles: paymentCyclesRes })

            } else {
                message.error(paymentCyclesRes?.errorMessage)
            }
        }
        catch (error: any) {
            message.error(error?.message || 'Something went wrong while fetching payment cycles')
        }
        this.setState({ loadingPaymentCycles: false })

    }

    getMainDropdowns = async () => {
        this.setState({
            loadingTags: true
        })

        try {
            const tagsRes = await this.props.getApi(getUserTagsApi);
            const res = await tagsRes.payload;

            if (res?.status !== 200) {
                message.error(res?.message || 'Failed to load tags');
                return;
            }

            const data = Array.isArray(res?.data) ? res.data : [];
            const normalizeTags = (tags: any[]) => (Array.isArray(tags) ? tags : []).map((tag: any) => ({
                id: tag?.id,
                name: tag?.name,
                subItems: (Array.isArray(tag?.subTags) ? tag.subTags : []).map((subTag: any) => ({
                    id: subTag?.id,
                    name: subTag?.name,
                })),
            }));

            let mainTagItems: any[] = [];
            let behavioralTagItems: any[] = [];
            let usageLevelItems: any[] = [];

            data.forEach((category: any) => {
                if (category?.id === UserTagCategories.Main) {
                    mainTagItems = normalizeTags(category?.tags);
                } else if (category?.id === UserTagCategories.Behavioral) {
                    behavioralTagItems = normalizeTags(category?.tags);
                } else if (category?.id === UserTagCategories.UsageLevel) {
                    usageLevelItems = normalizeTags(category?.tags);
                }
            });
            const info = this.props.info;
            if (info?.userTags?.length && this.formRef.current) {
                const mainTagFromInfo = info.userTags.find((tag: UserTag) => tag?.categoryID === UserTagCategories.Main);
                const mainTagID = mainTagFromInfo?.parentTagID ? mainTagFromInfo?.parentTagID : mainTagFromInfo?.tagID;
                const behavioralTagID = info?.userTags?.find((tag: UserTag) => tag?.categoryID ===
                    UserTagCategories.Behavioral)?.tagID;
                const usageLevelTagID = info?.userTags?.find((tag: UserTag) => tag?.categoryID ===
                    UserTagCategories.UsageLevel)?.tagID;
                const mainSubTagID = mainTagFromInfo?.parentTagID ? (mainTagFromInfo?.tagID ?? undefined) : undefined;
                this.formRef.current.setFieldsValue({
                    mainTag: mainTagID ?? undefined,
                    mainSubTag: !this.state.hasUserChangedMainTag ? mainSubTagID : undefined,
                    behavioralTag: behavioralTagID ?? undefined,
                    usageLevel: usageLevelTagID ?? undefined,
                });
            }
            if (info?.userTags?.length) {
                const mainTag = info.userTags.find((tag: UserTag) => tag?.categoryID === UserTagCategories.Main);
                const mainSubTags = mainTag?.parentTagID ? mainTagItems.find((item: any) => item.id === mainTag?.parentTagID)?.subItems : [];
                this.setState({
                    subTagItems: mainSubTags,
                    selectedMainTag: mainTag?.parentTagID ? mainTag?.parentTagID : mainTag?.tagID,
                });
            }
            this.setState({
                mainTagItems,
                behavioralTagItems,
                usageLevelItems,
                loadingTags: false
            });
        } catch (error) {
            this.setState({
                loadingTags: false
            })
            message.error('Something went wrong while loading tags');
        }
    }

    handleMainTagChange = (value: any) => {
        this.setState({ hasUserChangedMainTag: true });
        if (!value) {
            this.setState({
                selectedMainTag: null,
                subTagItems: [],
                selectedSubTag: null,
            });
            this.formRef.current?.setFieldsValue({
                mainSubTag: null,
            });
            return;
        }

        const selectedItem = (this.state.mainTagItems as any[]).find((item: any) => item.id === value);
        const subItems = (selectedItem?.subItems || []) as any[];

        this.setState({
            selectedMainTag: value,
            subTagItems: subItems,
            selectedSubTag: null,
        });

        this.formRef.current?.setFieldsValue({
            mainSubTag: null,
        });
    }

    handleBehavioralTagChange = (value: any) => {
        this.setState({
            selectedBehavioralTag: value,
        });
    }

    handleUsageLevelChange = (value: any) => {
        this.setState({
            selectedUsageLevel: value,
        });
    }

    handleSubTagChange = (value: any) => {
        this.setState({
            selectedSubTag: value,
        });
    }

    render() {
        const { subDrawer, drawerLayout, loadData, errorMode, errorMessage, otherComment, drawerWidth, visibleModal,
            status, reasons, title, sendCallDataSpin, subChildDrawer, drawerChildLayout,
            titleChild, modules, details, teamName, callTypes, outboundData, freePeriodsData,
            loadingTags
            // paymentCycles, loadingPaymentCycles
        } = this.state;
        const { info } = this.props;
        const requests = <>
            <div className="requests">
                <Divider orientation="left">Last Requests</Divider>
                <FewRequests userID={info} count={3} /><br />
                <div className="linksCollection">
                    {this.region === Region.EG &&
                        <>
                            <Button className='reqActions' onClick={() => this.openDrawer(<CreateRequestAction childComponent={true} />, 'Create Request')}>Create Request
                            </Button> <br />
                        </>}
                    <Button className='reqActions' onClick={() => this.openDrawer(<CancelRequest />, 'Cancel Request')}>Cancel Request
                    </Button><br />
                    <Button style={{ padding: '0' }} onClick={() => helper.setRedirect(`${this.region === Region.SE ? `https://se.dashboard.nowpay.cloud/question/471-call-center-all-requests-by-phone-or-requestid?phone=0&userId=${info && info.userID}&RequestID=0&staffid=-1` : `/dashboard/call-center-dashboard-transactions/${info && info.userID}`}`)} type="link">View All Requests</Button>
                </div>
            </div>
        </>
        const userInfo = <div className='userInfo'>
            <Divider orientation="left">User Information</Divider>

            {info && <Descriptions bordered>
                {info?.name && <Descriptions.Item span={3} label="Name">{info?.name}</Descriptions.Item>}
                {info?.userID && <Descriptions.Item span={3} label="User ID">{info?.userID}</Descriptions.Item>}
                {info?.staff_id && <Descriptions.Item label="Staff ID" span={3}>
                    {info?.staff_id}
                </Descriptions.Item>}
                {this.region === Region.EG && (
                    info?.userTags?.find((tag: UserTag) => tag?.categoryID === UserTagCategories.UsageLevel)?.tagName ? (
                        <Descriptions.Item span={3} label="User Level">
                            {renderUsageLevelFlag(
                                info?.userTags?.find((tag: UserTag) => tag?.categoryID === UserTagCategories.UsageLevel)?.tagID as UsageLevelTags)}
                        </Descriptions.Item>
                    ) : null)}
                {info?.companyName && <Descriptions.Item span={3} label="Company">{info?.companyName}</Descriptions.Item>}
                {info?.userID && <Descriptions.Item label="Actions" span={3}>
                    <span className='action' onClick={() => helper.setRedirect(this.region === Region.SE ? `https://se.dashboard.nowpay.cloud/question/1831-list-of-user-calls?userID=${info?.userID}` : `https://dashboard.nowpay.cloud/question/1831?userID=${info?.userID}`)}>Previous calls</span>
                    <br />
                    {this.region === Region.EG ? <>
                        <Link className='action' to={`/dashboard/call-center-dashboard/${info?.userID}`} target='_blank'>Main Dashboard</Link>
                        <br />
                        <Link className='action' to={`/dashboard/call-center-dashboard-activation/${info?.userID}`} target='_blank'>Activation</Link>
                        <br />
                        <Link className='action' to={`/dashboard/call-center-dashboard-transactions/${info?.userID}`} target='_blank'>Transactions</Link>
                        <br />
                        <Link className='action' to={`/dashboard/call-center-dashboard-lost-users/${info?.userID}`} target='_blank'>Lost Users</Link>
                        <br />
                    </>
                        :
                        <>
                            <span className='action' onClick={() => helper.setRedirect(`https://se.dashboard.nowpay.cloud/question/474-call-center-deductions-by-phone-or-requestid?RequestID=0&phone=0&userId=${info?.userID}&staffid=-1`)}>Deductions</span>
                            <br />
                            <span className='action' onClick={() => helper.setRedirect(`https://se.dashboard.nowpay.cloud/dashboard/411-call-center-main-dashboard?userid=${info?.userID}`)}>CallCenter Dashboard</span>
                            <br />
                            {/* <span className='action' onClick={() => helper.setRedirect(`https://se.dashboard.nowpay.cloud/question/471-call-center-all-requests-by-phone-or-requestid?phone=0&userId=${info?.userID}&RequestID=0&staffid=-1`)}>Requests</span> */}
                        </>
                    }

                    <span className='action' onClick={() => this.openChildDrawer(requests, ' Requests')}>Requests</span>
                    <br />
                    {this.region === Region.EG ?
                        <span className='action' onClick={() => this.openChildDrawer(<ViewEarlySettlement userInfo={info} />, 'View Early Settlement Discount')} >View Early Settlement Discount</span>
                        :
                        this.region === Region.SE ?
                            <>
                                <span className='action' onClick={() => this.openDrawer(<SendUserOtp phone={this.props.info?.phone} />, 'Get OTP')}>Send OTP</span>
                                <br />
                            </>
                            : null}
                </Descriptions.Item>}

            </Descriptions>}
        </div>;
        const userFreePeriod =
            <Collapse className="freePeriodInfo">
                <Panel header="User free period" key="1">
                    <Descriptions bordered column={4}>
                        <Descriptions.Item span={2} label="Free period end date">{freePeriodsData?.freePeriodsEndDate ? Helper.changeDateFormat(freePeriodsData?.freePeriodsEndDate) : 'NA'}</Descriptions.Item>
                        <Descriptions.Item span={2} label="Cut off day">{freePeriodsData?.cutOffDay ? freePeriodsData?.cutOffDay : 'NA'}</Descriptions.Item>
                        <Descriptions.Item span={2} label="Company deployment date">{freePeriodsData?.companyDeploymentDate ? Helper.changeDateFormat(freePeriodsData?.companyDeploymentDate) : 'NA'}</Descriptions.Item>
                        <Descriptions.Item span={2} label="Company free period">{freePeriodsData?.companyFreePeriod ? freePeriodsData?.companyFreePeriod : 0}</Descriptions.Item>
                        <Descriptions.Item span={2} label={!freePeriodsData?.companyUsersFreePeriodStarted ?
                            <><span>User first request date</span> &nbsp; <Tooltip title={`the user has ${freePeriodsData?.companyUsersFreePeriod} free months but the periods hasn't started yet`}>
                                <InfoCircleOutlined style={{ color: 'red', fontWeight: 500 }} />
                            </Tooltip></>
                            : 'User first request date'}> {freePeriodsData?.userFirstRequestDate ? Helper.changeDateFormat(freePeriodsData?.userFirstRequestDate) : 'NA'}</Descriptions.Item>
                        <>
                            {/*  */}
                            {Number(freePeriodsData?.companyUsersFreePeriod) < 3 ? <Descriptions.Item span={2} label={
                                <span>
                                    Users free period &nbsp; <Tooltip title=" Free Period is less than 3 months">
                                        <InfoCircleOutlined style={{ color: 'red', fontWeight: 500 }} />
                                    </Tooltip> &nbsp;
                                </span>}>{freePeriodsData?.companyUsersFreePeriod ?
                                    <span style={{ color: 'red', fontWeight: 500 }}>{freePeriodsData?.companyUsersFreePeriod}</span> : 0}
                            </Descriptions.Item> : <Descriptions.Item span={2} label='Users free period'>
                                {freePeriodsData?.companyUsersFreePeriod ?
                                    freePeriodsData?.companyUsersFreePeriod : 'NA'}
                            </Descriptions.Item>}
                            <Descriptions.Item span={2} label="VIP User start date">{freePeriodsData?.userVIPStartDate ? Helper.changeDateFormat(freePeriodsData?.userVIPStartDate) : 'NA'}</Descriptions.Item>
                        </>

                        <Descriptions.Item span={2} label="VIP User free period">{freePeriodsData?.userVIPFreePeriod ? freePeriodsData?.userVIPFreePeriod : 0}</Descriptions.Item>

                        <Descriptions.Item span={2} label="Free Period on Deductions">{freePeriodsData?.freePeriodOnDeductions ? TrueIcon : FalseIcon}</Descriptions.Item>


                    </Descriptions>
                </Panel>
            </Collapse>

        const callInfo = <>
            <Divider orientation="left">Call Information</Divider>
            {/* {this.region === Region.SE && <Divider orientation="left">Call Information</Divider>} */}
            <Spin spinning={outboundData}>

                <Form name="nest-messages" ref={this.formRef} onFinish={this.endCall}>
                    {/* {this.region === Region.EG &&
                        <>
                            <Divider orientation="left">User Device Status</Divider>
                            <div className="device-status-card">
                                <div className="device-status-card__left">
                                    <span className="device-status-card__dot" />
                                    <div>
                                        <span className="device-status-card__label">Verified for shared devices</span>
                                        <span className="device-status-card__sub">This flag is sent when you end the call</span>
                                    </div>
                                </div>
                                <Form.Item name="isVerified" valuePropName="checked" initialValue={this.state.isVerified} style={{ marginBottom: 0 }}>
                                    <Switch checkedChildren="Yes" unCheckedChildren="No" />
                                </Form.Item>
                            </div>
                        </>
                    } */}
                    <Divider orientation="left">User Login Status</Divider>
                    <div className={`device-status-card${this.state.isLoginBlocked ? ' device-status-card--blocked' : ''}`}>
                        <div className="device-status-card__left">
                            <span className={`device-status-card__dot${this.state.isLoginBlocked ? ' device-status-card__dot--blocked' : ''}`} />
                            <div>
                                <span className="device-status-card__label">Login Blocked</span>
                                <span className="device-status-card__sub">
                                    {this.state.isLoginBlocked
                                        ? 'Turn off to unblock this user from logging in'
                                        : 'User can currently log in'}
                                </span>
                            </div>
                        </div>
                        <Switch
                            checked={this.state.isLoginBlocked}
                            loading={this.state.updatingLoginStatus}
                            disabled={!this.state.isLoginBlocked}
                            onChange={this.handleLoginBlockedChange}
                            checkedChildren="Yes"
                            unCheckedChildren="No"
                        />
                    </div>
                    <Divider orientation="left">Call Information</Divider>
                    <Row>
                        <Col span={10} style={{ padding: '0 15px 0 0' }}>
                            <label htmlFor="">Comment </label>
                            <Form.Item name="comment" initialValue={''} rules={[{ required: false, message: 'Required' }]}>
                                <Input.TextArea style={{ height: '110px' }} placeholder='Enter Comment' />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ margin: '0px 0 20px 0' }}>
                            <Row>

                                {this.region === Region.EG && <Col className='status' span='24'>
                                    <label>Status </label>

                                    <Form.Item
                                        name="status"
                                        rules={[{ required: true, message: 'Required' }]}

                                    >
                                        <Select
                                            placeholder="Enter Status">
                                            {status?.map((service: any, key: number) => {
                                                return <Option value={service.id} key={key}>{service.name}</Option>
                                            })}
                                        </Select>
                                    </Form.Item>

                                </Col>}

                                <Col className='reason' span='24'>
                                    <label>{this.region === Region.EG ? 'Inquiry Type' : 'Reason'} </label>
                                    <Form.Item
                                        name="reason"
                                        rules={[{ required: true, message: 'Required' }]}

                                    >
                                        <Select
                                            placeholder={this.region === Region.EG ? 'Enter Inquiry Type' : 'Enter Reason'}>
                                            {reasons?.map((service: any, key: number) => {
                                                return <Option value={service.id} key={key}>{service.name}</Option>
                                            })}
                                        </Select>
                                    </Form.Item>

                                </Col>
                            </Row>
                        </Col>
                        <Col span={6} style={{ margin: '10px 0 0px 0', padding: '0 20px' }}>
                            <Form.Item label='Out Bound Call' name="outboundCall" valuePropName="checked" initialValue={false}>
                                <Switch defaultChecked={false} onChange={this.outBoundChange} />
                            </Form.Item>
                            {this.state.outboundCall && <span className='action' style={{ marginTop: '30px', display: 'block' }} onClick={this.handleToggleTheModal}>Collection Plans</span>}
                        </Col>
                        <Col className='module' span='8' style={{ padding: '0 15px 0 0' }}>
                            <label>{this.region === Region.EG ? 'Call Reason' : 'Modules'} </label>

                            <Form.Item
                                name="module"
                                rules={[{ required: true, message: 'Required' }]}

                            >
                                <Select
                                    onChange={this.gettingDetails}
                                    placeholder={this.region === Region.EG ? 'Enter Call Reason' : 'Enter Modules'}>
                                    {modules?.map((module: any, key: number) => {
                                        return <Option value={module.id} module={module} key={key}>{module.name}</Option>
                                    })}
                                </Select>
                            </Form.Item>

                        </Col>
                        <Col className='detail' span='8' style={{ padding: '0 15px 0 0' }}>
                            <label>{this.region === Region.EG ? 'Sub-Reason' : 'Details'} </label>
                            <Form.Item
                                name="details"
                                rules={[{ required: true, message: 'Required' }]}

                            >
                                <Select
                                    onChange={this.onOtherSelected}
                                    disabled={details?.length === 0}
                                    placeholder={this.region === Region.EG ? 'Enter Sub-Reason' : 'Enter Details'}>
                                    {details?.map((detail: any, key: number) => {
                                        return <Option value={detail.id} name={detail} key={key}>{detail.name}</Option>
                                    })}
                                </Select>
                            </Form.Item>

                        </Col>
                        <Col className='callType' span='8'>
                            <label>{this.region === Region.EG ? 'Channel' : 'Call Type'} </label>
                            <Form.Item
                                name="callType"
                                rules={[{ required: true, message: 'Required' }]}

                            >
                                <Select
                                    onChange={this.onOtherSelected}
                                    placeholder={this.region === Region.EG ? 'Enter Channel' : 'Enter Call Type'}>
                                    {callTypes?.map((detail: any, key: number) => {
                                        return <Option value={detail.id} name={detail} key={key}>{detail.name}</Option>
                                    })}
                                </Select>
                            </Form.Item>

                        </Col>
                        {otherComment && <Col span={24} style={{ marginTop: '10px' }}>
                            <label htmlFor=""><b>Brief The details</b> </label>
                            <Form.Item name="otherComment" initialValue={''} rules={[{ required: true, message: 'Required' }]}>
                                <Input.TextArea style={{ height: '110px' }} placeholder='Enter Comment' />
                            </Form.Item>
                        </Col>}

                    </Row>
                    {this.region === Region.EG && <Row gutter={[24, 24]} style={{ marginTop: '24px' }}>
                        {loadingTags ? (
                            <>
                                <Col span={8}>
                                    <div className="tag-card" style={{ padding: '16px' }}>
                                        <Skeleton.Input active size="small" style={{ width: 80, marginBottom: 12 }} />
                                        <Skeleton.Input active block style={{ height: 40 }} />
                                    </div>
                                </Col>
                                <Col span={8}>
                                    <div className="tag-card" style={{ padding: '16px' }}>
                                        <Skeleton.Input active size="small" style={{ width: 100, marginBottom: 12 }} />
                                        <Skeleton.Input active block style={{ height: 40 }} />
                                    </div>
                                </Col>
                                <Col span={8}>
                                    <div className="tag-card" style={{ padding: '16px' }}>
                                        <Skeleton.Input active size="small" style={{ width: 90, marginBottom: 12 }} />
                                        <Skeleton.Input active block style={{ height: 40 }} />
                                    </div>
                                </Col>
                            </>
                        ) : (
                            <>
                                <Col span={8}>
                                    <div className="tag-card">
                                        <label className="tag-label">
                                            Main Tag
                                        </label>
                                        <Form.Item name="mainTag" style={{ marginBottom: '16px' }}>
                                            <Select
                                                placeholder="Select an option"
                                                onChange={this.handleMainTagChange}
                                                allowClear
                                                style={{ width: '100%' }}
                                                size="large"
                                            >
                                                {this.state.mainTagItems?.map((item: any, key: number) => {
                                                    return <Option value={item.id} key={key}>{item.name}</Option>
                                                })}
                                            </Select>
                                        </Form.Item>
                                        {this.state.selectedMainTag && this.state.subTagItems.length > 0 && (
                                            <div style={{
                                                marginTop: '16px',
                                                paddingTop: '16px',
                                                borderTop: '2px solid #d9d9d9',
                                                animation: 'fadeIn 0.3s ease-in'
                                            }}>
                                                <label className="tag-label-sub">
                                                    Sub Tag
                                                </label>
                                                <Form.Item
                                                    name="mainSubTag"
                                                    rules={[
                                                        {
                                                            validator: (_: any, value: any) => {
                                                                if (this.state.selectedMainTag && this.state.subTagItems.length > 0 && !value) {
                                                                    return Promise.reject('Please select a sub item');
                                                                }
                                                                return Promise.resolve();
                                                            }
                                                        }
                                                    ]}
                                                    style={{ marginBottom: 0 }}
                                                >
                                                    <Select
                                                        placeholder="Select a sub option"
                                                        onChange={this.handleSubTagChange}
                                                        allowClear
                                                        style={{ width: '100%' }}
                                                        size="large"
                                                    >
                                                        {this.state.subTagItems?.map((item: any, key: number) => {
                                                            return <Option value={item.id} key={key}>{item.name}</Option>
                                                        })}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                                <Col span={8}>
                                    <div className="tag-card">
                                        <label className="tag-label">
                                            Behavioral Tag
                                        </label>
                                        <Form.Item name="behavioralTag" style={{ marginBottom: '16px' }}>
                                            <Select
                                                placeholder="Select an option"
                                                onChange={this.handleBehavioralTagChange}
                                                allowClear
                                                style={{ width: '100%' }}
                                                size="large"
                                            >
                                                {this.state.behavioralTagItems?.map((item: any, key: number) => {
                                                    return <Option value={item.id} key={key}>{item.name}</Option>
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </Col>
                                <Col span={8}>
                                    <div className="tag-card">
                                        <label className="tag-label">
                                            Usage Level
                                        </label>
                                        <Form.Item name="usageLevel" style={{ marginBottom: '16px' }}>
                                            <Select
                                                placeholder="Select an option"
                                                onChange={this.handleUsageLevelChange}
                                                allowClear
                                                style={{ width: '100%' }}
                                                size="large"
                                            >
                                                {this.state.usageLevelItems?.map((item: any, key: number) => {
                                                    return <Option value={item.id} key={key}>{item.name}</Option>
                                                })}
                                            </Select>
                                        </Form.Item>
                                    </div>
                                </Col>
                            </>
                        )}
                    </Row>}
                    <Row style={{ margin: '15px 0 0 0' }}>
                        <Col span={6}>
                            <Form.Item label='Call interrupted' name="callInteracted" valuePropName="checked" initialValue={false}>
                                <Switch defaultChecked={false} />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item label='Open zoho ticket' name="openZohoTicket" valuePropName="checked" initialValue={false}>
                                <Switch defaultChecked={false} />
                            </Form.Item>
                        </Col>
                        <Col span={6} style={{ padding: '5px 20px' }}>{teamName && <>Team : {teamName}</>}</Col>



                        <Col span={6} ><Form.Item>
                            <Button className='endCallBtn' type="primary" danger htmlType="submit" loading={sendCallDataSpin} >
                                End Call
                            </Button>
                        </Form.Item></Col>
                    </Row>

                </Form>
            </Spin>
        </>
        const sudDrawer = <CommonDrawer cancelDrawer={this.closeDrawer} drawerWidth={820}
            visible={subDrawer} drawerLayout={drawerLayout} showDrawer={this.openDrawer} drawerTitle={title} />
        const childDrawer = <CommonDrawer cancelDrawer={this.closeChildDrawer} drawerWidth={drawerWidth}
            visible={subChildDrawer} drawerLayout={drawerChildLayout} showDrawer={this.openChildDrawer} drawerTitle={titleChild} />
        return (
            <>
                <div className='callInfo'>
                    {loadData ? <Spinner size={'large'} /> : errorMode ? <OutPutResult status={'500'} title={'Oops!'} subTitle={errorMessage ? errorMessage : 'Something went wrong, please refresh the page and try again'}
                        btnTitle={'Refresh the page'} btnClick={this.refreshPage} /> : <>
                        {userInfo}
                        {userFreePeriod}
                        {/* {settlementInfo} */}
                        {callInfo}
                        {childDrawer}
                        {/* {modal} */}
                        {sudDrawer}
                    </>}
                </div>
                <TruckingModal title='Collection Plan' handleCloseModal={this.handleToggleTheModal} visibleModal={visibleModal} content={<CollectionPlans onCancel={this.handleToggleTheModal} userID={info?.userID as number} />} />
            </>
        )
    }
}
const mapStateToProps = (state: any) => ({
    info: state.actionsReducer.info,
})
export default connect(mapStateToProps, { getApi, postApi, patchApi, stepperMoving })(CallInfo)